module.exports = __webpack_public_path__ + "img/upload-lateral1-exotics.b83dd0e5.jpg";